var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],class:{show: _vm.isToast},attrs:{"data-transfer":true}},[(_vm.status==='success')?_c('Icon',{attrs:{"type":"checkmark-circled"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.msg)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }